import { useGraphql } from "@dustin-web/microsite-data/src/hooks"
import { GetLandingPageQuery, QueryLandingPageArgs } from "@dustin-web/microsite-data/src/graphql/product/generated/graphql-types"
import { GET_LANDING_PAGE } from "@dustin-web/microsite-data/src/graphql/product/get-landing-page.graphql"

type LandingPageQueryVariables = Omit<QueryLandingPageArgs, 'pageSize' | 'page'>

export const useLandingPage = (queryVariables: LandingPageQueryVariables, skip: boolean, shouldQuery: boolean = true) => {
  return useGraphql<GetLandingPageQuery, QueryLandingPageArgs>(GET_LANDING_PAGE, {
    context: { skip },
    variables: {
      pageSize: 100,
      page: 1,
      ...queryVariables,
    },
  }, shouldQuery)
}

